function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 82.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.51,29.5a.3.3,0,0,0-.12-.39L6.28,25.83a.3.3,0,0,0-.39.11.29.29,0,0,0,.12.39l6.11,3.28a.22.22,0,0,0,.13,0,.3.3,0,0,0,.26-.15m1.3,2.13a.28.28,0,0,0-.11-.38l-7.42-4a.29.29,0,0,0-.27.51l7.42,4a.31.31,0,0,0,.13,0,.27.27,0,0,0,.25-.15M9.09,51.55a.71.71,0,0,0,.3,1l9.7,5.11a.8.8,0,0,0,.33.08.71.71,0,0,0,.33-1.34l-9.7-5.1a.71.71,0,0,0-1,.29m0-3.54a.71.71,0,0,0,.3,1l12.14,6.39a.8.8,0,0,0,.33.08.71.71,0,0,0,.33-1.34L10.05,47.71a.71.71,0,0,0-1,.3m0-3.55a.71.71,0,0,0,.3,1l17.83,9.39a.8.8,0,0,0,.33.08.71.71,0,0,0,.33-1.34L10.05,44.17a.72.72,0,0,0-1,.29m0-3.54a.71.71,0,0,0,.3,1L24,49.58a.8.8,0,0,0,.33.08.72.72,0,0,0,.63-.38.71.71,0,0,0-.3-1l-14.63-7.7a.71.71,0,0,0-1,.3M5.89,30.28a.29.29,0,0,0,.12.39l4.1,2.22a.22.22,0,0,0,.13,0,.29.29,0,0,0,.26-.15.3.3,0,0,0-.12-.39l-4.1-2.22a.29.29,0,0,0-.39.11m0-1.44a.28.28,0,0,0,.12.38L11.11,32a.33.33,0,0,0,.13,0,.29.29,0,0,0,.25-.15.28.28,0,0,0-.11-.39l-5.1-2.75a.3.3,0,0,0-.39.12m59.55-9.09L51.63,27,21.2,11,35,3.73ZM19.32,12,49.75,28,35,35.77l-30.43-16ZM34.13,78.08,3.5,62V21.16L34.13,37.29ZM66.51,21.16V39.4H51V55.33H66.51V62L35.88,78.08V37.29L37,36.7ZM80.25,31.62V39.4H70V19.25a1.74,1.74,0,0,0-.93-1.54L35.82.2a1.74,1.74,0,0,0-1.63,0L.94,17.71A1.73,1.73,0,0,0,0,19.25V63a1.75,1.75,0,0,0,.93,1.55l33.26,17.5a1.76,1.76,0,0,0,1.63,0l33.26-17.5A1.75,1.75,0,0,0,70,63V55.33H80.25v7.79L96,47.37Z",
    style: {
      fill: "#707070"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send2.5a1e8ea908b5e7b40eaf6ad9edb8f9ac.svg";
export { ForwardRef as ReactComponent };